import React,{useState, useEffect, Children } from 'react';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Button from 'react-bootstrap/Button';
import MobileNav from '../Component/MobileNav'; 
// import { Link, useNavigate } from 'react-router-dom';
// import Search from '../Component/Search';
import {Link, useNavigate} from 'react-router-dom';
function Header() {
// addremove class on search
// Hover Dropdown
const [show, setShow] = useState(false);
const [showmore, setShowmore] = useState(false);
const [Showmoresub, setShowmoresub] = useState(false);
const [showexplore, setShowexplore] = useState(false);
const [showone, setShowOne] = useState(false);
const [showtwo, setShowTwo] = useState(false);
const [showthree, setShowThree] = useState(false);
const [showtwoone, setShowTwoOne] = useState(false);
const showDropdown = (e)=>{
setShow(!show);
}
const hideDropdown = e => {
setShow(false);
}
const showDropdownMore = (e)=>{
setShowmore(!showmore);
}
const hideDropdownMore = e => {
setShowmore(false);
}
const showDropdownExplore = (e)=>{
setShowexplore(!showexplore);
}
const hideDropdownExplore = e => {
setShowexplore(false);
}
// showDropdownMoresub
const showDropdownMoresub = (e)=>{
setShowmoresub(!Showmoresub);
}
const hideDropdownMoresub = e => {
setShowmoresub(false);
}
// One
const showDropdownOne = (e)=>{
setShowOne(!showone);
}
const hideDropdownOne = e => {
setShowOne(false);
}
// two
const showDropdownTwo = (e)=>{
setShowTwo(!showtwo);
}
const hideDropdownTwo = e => {
setShowTwo(false);
}
// two one
const showDropdownTwoOne = (e)=>{
setShowTwoOne(!showtwoone);
}
const hideDropdownTwoOne = e => {
setShowTwoOne(false);
}
const showDropdownThree = (e)=>{
setShowThree(!showthree);
}
const hideDropdownThree = e => {
setShowThree(false);
}
// Hover Dropdown
// addremove class on search
const handleFocus = e => {
e.target.classList.add("SerchActive");
e.target.placeholder = "Type Here"
};
const handleBlur = e => {
e.target.classList.remove("SerchActive");
e.target.placeholder = "Search"
};
// addremove class on search
// State Set for form and redirect and transfer state data to another component
const [state, setState] = React.useState('');
const navigate = useNavigate();
const searchGoogle = async (e) => {
e.preventDefault()
// transfert in target value on submit state
navigate("/SearchResults", { state: state });
// transfert in target value on submit state
console.log(state,"State");
};
// ctmHeader
// document.querySelectorAll('.menu-Bar').forEach(function(menuBar) {
//     menuBar.addEventListener('click', function() {
//       document.querySelectorAll('.menu-Bar').forEach(function(item) {
//         item.classList.toggle('open');
//       });
//       document.querySelectorAll('.menuWrap').forEach(function(menuWrap) {
//         menuWrap.classList.toggle('open');
//       });
//     });
//   });
  
// document.querySelectorAll('.menu-Bar').forEach(function(menuBar) {
//     menuBar.addEventListener('click', function() {
//               document.querySelectorAll('.menu-Bar').forEach(function(item) {
//                 item.classList.toggle('open');
//               });
//             });
// });  


//   $(".menu-Bar").click(function(){
//   $(".menu-Bar").toggleClass("open");
//  $(".menuWrap").toggleClass("open");
// });




// State Set for form and redirect and transfer state data to another component
return (
<>
    <header className="App-header">
        <div className="container-fluid">
            <Navbar expand="lg">
                <div className='logoHumberg'>
                <Navbar.Brand to="/" as={Link}>
                    <img src="https://habib.edu.pk/dev-library/assets/img/header-logo.png" alt="" className="img-fluid desktop-logo" />
                    <img src="https://habib.edu.pk/dev-library/assets/img/responsive-logo.svg" alt="" className="img-fluid responsive-logo" />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                </div>
                <div className='header-right'>
                    <div className="header-top">
                        {/* <div className="header-box">
                            <h6>Space Availability</h6>
                            <p>24% is full</p>
                        </div> */}
                        <div className="header-box">
                            <h6>
                                <img src='https://habib.edu.pk/dev-library/assets/img/open-hours-icon.svg' className='img-fluid' alt="" />
                                Open Hours
                            </h6>
                            <p>Mon to Fri 8:00 AM to 7:30 PM </p>
                            <p>Working Saturday 8:00 AM to 5:00 PM </p>
                        </div>
                        <div className="header-box">
                            <h6>
                                <img src='https://habib.edu.pk/dev-library/assets/img/book-session-icon.svg' className='img-fluid' alt="" />
                                Book one on one Session
                            </h6>
                            <p>Schedule a meeting by submitting a request form </p>
                            <Link as={Link} to="/BookSession" className='btn-dfault'>
                            Book Session
                            </Link>
                        </div>
                        <div className="header-box">
                            <NavDropdown title="Explore Habib University" id="basic-nav-dropdown" show={showexplore} onMouseEnter={showDropdownExplore} onMouseLeave={hideDropdownExplore}>
                                <NavDropdown.Item target="_blank" href="https://habib.edu.pk/">Campus Website</NavDropdown.Item>
                                <NavDropdown.Item target="_blank" href="https://habib.edu.pk/admissions/">Admissions</NavDropdown.Item>
                                <NavDropdown.Item target="_blank" href="https://habib.edu.pk/academics/">Academics</NavDropdown.Item>
                                <NavDropdown.Item target="_blank" href="https://habib.edu.pk/student-affairs/">Students</NavDropdown.Item>
                                <NavDropdown.Item target="_blank" href="https://habib.edu.pk/HU-news/">News</NavDropdown.Item>
                            </NavDropdown>
                        
                        </div>
                    </div>
    <div className="header-bottom">
        <div className="inner-header-btm">
            <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="main-nav">
                    <li className='nav-item home-item'>
                        <Nav.Link as={Link} to="/"> <img className='img-fluid me-2' src='https://habib.edu.pk/dev-library/assets/img/home-icon.svg' alt="" />Home</Nav.Link>
                    </li>
                    <li className='nav-item'>
                    {/* title={<Link to="/About" as={Link}>About</Link>} */}
                    <NavDropdown title={<Link to="/About" as={Link}>About</Link>} id="basic-nav-dropdown" show={show} onMouseEnter={showDropdown} onMouseLeave={hideDropdown}>
                            <NavDropdown.Item as={Link} to="/LibraryHours">Library Hours</NavDropdown.Item>
                            <NavDropdown className='subdropdownNav' title="Patron/User Policies" id="" show={Showmoresub} onMouseEnter={showDropdownMoresub} onMouseLeave={hideDropdownMoresub}>
                                <NavDropdown.Item as={Link} to="/BorrowingPolicies">Borrowing Policies</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/ComputerUsePolicy">Computer Use Policy</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/DiscussionRoomsPolicy">Discussion Rooms Policy</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/FinesPenalty">General Rules Fines</NavDropdown.Item>
                            </NavDropdown>
                            <NavDropdown.Item as={Link} to="/InternshipAndStudentEmploymentOpportunities">Internship & Student Employment Opportunities</NavDropdown.Item>
                        </NavDropdown>
                    </li>
                    <li className='nav-item firstDropDown'>
                        <NavDropdown title="Explore" id="basic-nav-dropdown" show={showone}
                            onMouseEnter={showDropdownOne}
                            onMouseLeave={hideDropdownOne}>
                            <NavDropdown.Item as={Link} to="/CollaborativeWorkingAndLearningSpaces">Collaborative Working and Learning Spaces</NavDropdown.Item>
                            <NavDropdown.Item as={Link} to="/ComputerAndTechnology">Computer and Technology (Equipment)</NavDropdown.Item>
                            <NavDropdown.Item as={Link} to="/PrintingScanningAndPhotocopying">Printing, Scanning and Photocopying</NavDropdown.Item>
                            <NavDropdown.Item as={Link} to="/LibraryServices">Library Services</NavDropdown.Item>
                            <NavDropdown.Item as={Link} to="/MakerSpace">Maker Space</NavDropdown.Item>
                        </NavDropdown>
                    </li>
                    <li className='nav-item secondDropDown'>
                        <NavDropdown title={<Link to="/FindResources" as={Link}>Find Resources</Link>} id="showtwo" show={showtwo} onMouseEnter={showDropdownTwo} onMouseLeave={hideDropdownTwo}>
                            <NavDropdown.Item target="_blank" href="https://catalog.habib.edu.pk/">Book/Catalog</NavDropdown.Item>
                            <NavDropdown.Item target="_blank" href="https://hira.habib.edu.pk/jspui/">HIRA (Habib Institutional Repository & Archive)</NavDropdown.Item>
                            {/* Inner Dropdown */}
                            <NavDropdown className='subdropdownNav' title="E-Resources/Databases" id="showtwoone" show={showtwoone} onMouseEnter={showDropdownTwoOne} onMouseLeave={hideDropdownTwoOne}>
                                <NavDropdown.Item as={Link} to="/DSSE">DSSE </NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/AHSS">AHSS </NavDropdown.Item>
                            </NavDropdown>
                            {/* Inner Dropdown */}
                            <NavDropdown.Item as={Link} to="/FreeOpenAccessResources">Free/Open Access Resource </NavDropdown.Item>
                            <NavDropdown.Item as={Link} to="/NewspaperMagazine">Newspaper and Magazines </NavDropdown.Item>
                        </NavDropdown>
                    </li>
                    <li className='nav-item'>
                        <NavDropdown title={<Link to="/ResearchSupport" as={Link}>Research Support</Link>} id="basic-nav-dropdown" show={showthree}
                            onMouseEnter={showDropdownThree}
                            onMouseLeave={hideDropdownThree}>
                            <NavDropdown.Item as={Link} to="/BookSession">Book ‘One on one’ session</NavDropdown.Item>
                            {/* <NavDropdown.Item as={Link} to="/BookSession">Article Request Form/Inter Library Loan</NavDropdown.Item> */}
                            <NavDropdown.Item as={Link} to="/EventCalendar">Upcoming Trainings/Workshops</NavDropdown.Item>
                            <NavDropdown.Item as={Link} to="/SelfLearningResources">Self-Learning Resources</NavDropdown.Item>
                            {/* <NavDropdown.Item as={Link} to="/">Videos & Tutorials</NavDropdown.Item> */}
                        </NavDropdown>
                    </li>



                    
                    
                    
                    {/* <li className='nav-item'>
                        <NavDropdown title="Contact" id="basic-nav-dropdown" show={showmore} onMouseEnter={showDropdownMore} onMouseLeave={hideDropdownMore}>
                            <NavDropdown.Item as={Link} to="/ResourceRequest">Resource Request</NavDropdown.Item>
                            <NavDropdown.Item as={Link} to="/AskaLibrarian">Ask a Librarian</NavDropdown.Item>
                            <NavDropdown.Item as={Link} to="/Faq">FAQ's</NavDropdown.Item>
                            <NavDropdown.Item as={Link} to="/RightsandResponsibilities">Right & Responsibilities</NavDropdown.Item>
                            <NavDropdown.Item as={Link} to="/EventCalendar">Events Calender</NavDropdown.Item>
                        </NavDropdown>
                    </li> */}
                    {/* <li className='nav-item'>
                        <Nav.Link href='https://catalog.habib.edu.pk/' target='_blank'>Catalog</Nav.Link>
                    </li> */}
                    {/* <li className='nav-item'>
                    <Nav.Link href='https://vpn.habib.edu.pk/' target='_blank'>Off Campus Access</Nav.Link>
                    </li> */}
                    <li className='nav-item'>
                        <Nav.Link as={Link} to="/ResourceRequest">Resource Request</Nav.Link>
                    </li>
                    <li className='nav-item'>
                        <Nav.Link as={Link} to="/Faq">FAQ's</Nav.Link>
                    </li>
                    <li className='nav-item'>
                        <Nav.Link as={Link} to="/AskaLibrarian">Contact</Nav.Link>
                    </li>
                </Nav>
                <div className="rispon-menu-bottom">
                    <div className="header-box">
                        <h6>
                            <img src='https://habib.edu.pk/dev-library/assets/img/book-session-icon.svg' className='img-fluid' alt="" />
                            Book one on one Session
                        </h6>
                        <p>Schedule a meeting by submitting a request form </p>
                        <Link as={Link} to="/BookSession" className='btn-dfault'>
                        Book Session
                        </Link>
                    </div>
                    {/* <div className="menu-footer">
                        <p>© Habib University - All Rights Reserved</p>
                        <p>
                            <Link to="">Privacy Statement</Link>
                        </p>
                    </div> */}
                </div>
            </Navbar.Collapse>
            <Form className="search-bar-header" onSubmit={searchGoogle}>
                <InputGroup>
                    <Button variant="" id="search-nav">
                        <img src='https://habib.edu.pk/dev-library/assets/img/search-icon.svg' alt="" />
                    </Button>
                    <Form.Control placeholder="Search" aria-label="Search" aria-describedby="search-nav" onFocus={handleFocus} onBlur={handleBlur} onChange={(e)=> setState(e.target.value)}
                        value={state}
                        />
                </InputGroup>
            </Form>
        </div>
    </div>
                </div>
            </Navbar>
        </div>
        <MobileNav />
        
    </header>
</>

);
}
export default Header;